import { render, staticRenderFns } from "./manual-assign.vue?vue&type=template&id=86bc2836&scoped=true&"
import script from "./manual-assign.component.ts?vue&type=script&lang=ts&"
export * from "./manual-assign.component.ts?vue&type=script&lang=ts&"
import style0 from "./manual-assign.scss?vue&type=style&index=0&id=86bc2836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bc2836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86bc2836')) {
      api.createRecord('86bc2836', component.options)
    } else {
      api.reload('86bc2836', component.options)
    }
    module.hot.accept("./manual-assign.vue?vue&type=template&id=86bc2836&scoped=true&", function () {
      api.rerender('86bc2836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-v2/manual-assign/manual-assign.vue"
export default component.exports